<template>
  <v-dialog-reservaqui
    :visivel="visivel"
    tipo="confirma"
    :mensagem="mensagem"
    :corpoMensagem="corpoMensagem"
    @close="$emit('close')"
    @confirma="$emit('confirma')" />
</template>

<script>
import VDialogReservaqui from "@/components/base/VDialogReservaqui"

export default {
  name: "v-delele-dialog",
  components: { VDialogReservaqui },
  props: {
    visivel: {
      type: Boolean,
    },
    mensagem: {
      type: String,
    },
    corpoMensagem: {
      type: String,
    },
  },
}
</script>
